import * as React from 'react';

interface IProps {}

const PIXEL_COUNT = 8;

const PixelsPanel: React.FC<IProps> = ({}) => {
  const pixels = React.useMemo(() => {
    const generatedPixels = [];
    for (let i = 0; i < PIXEL_COUNT; i++) {
      generatedPixels.push({
        top: `${Math.random() * 90 + 5}%`,
        left: `${Math.random() * 90 + 5}%`,
        animationDelay: `${Math.random() * 3}s`,
        animationDuration: `${2 + Math.random() * 2}s`,
      });
    }
    return generatedPixels;
  }, []);

  return (
    <div className="pixels-panel">
      {pixels.map((pixel, index) => (
        <span key={index} className="pixels-panel__pixel" style={pixel}></span>
      ))}
    </div>
  );
};
export default PixelsPanel;
